import React from 'react';
import './App.css';
import './styles/common.css'; // Import our common styles
import IndexingControlPanel from './components/IndexingControlPanel';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header';

function App() {
    return (
        <div className="App">
            <Header />
            <IndexingControlPanel />
        </div>
    );
}

export default App;
